<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle" style="margin-top: 10px; margin-bottom: 5px">
            <el-breadcrumb-item :to="{ path: '/repertoryList' }">库存</el-breadcrumb-item>
            <el-breadcrumb-item>批量编辑</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item">
                <vDropdown
                    model_key="product_rid"
                    model_name="请选择产品"
                    :model_value_default="queryParams['product_rid']"
                    request_uri="dropdownProducts"
                    :request_params="{ type_code: [11, 91] }"
                    @onDropChange="onDropChange"
                    ref="product_rid_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item">
                <vDropdown
                    model_key="partner_rid"
                    model_name="请选择合作方"
                    :model_value_default="queryParams['partner_rid']"
                    request_uri="dropdownPartners"
                    @onDropChange="onDropChange"
                    ref="partner_rid_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item">
                <vSearchSelect
                    model_key="business_rid"
                    model_name="请输入一级商业搜索"
                    request_uri="searchAccounts"
                    default_option_key="business_option"
                    :default_option="queryParams['business_option']"
                    @onDropChange="onDropChange"
                    ref="business_rid_ref"
                ></vSearchSelect>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="principal_rid"
                    model_name="请选择负责人"
                    request_uri="dropdownPerson"
                    :model_value_default="queryParams['principal_rid']"
                    @onDropChange="onDropChange"
                    ref="principal_rid_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vSearchSelect
                    model_key="product_owner_rid"
                    model_name="请输入产品所有者搜索"
                    request_uri="searchAccounts"
                    default_option_key="product_owner_option"
                    :default_option="queryParams['product_owner_option']"
                    @onDropChange="onDropChange"
                    ref="product_owner_rid_ref"
                ></vSearchSelect>
            </div>

            <div class="main_header_item">
                <el-date-picker
                    v-model="queryParams['date_range']"
                    type="daterange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    size="small"
                    style="width: 300px"
                >
                </el-date-picker>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="batchSave" v-if="postList.batchSaveBtn" :loading="save_loading">批量保存</el-button>
                <span style="color: red; font-size: 13px"> &nbsp;&nbsp;&nbsp;&nbsp;注意：超过关闭日期的数据不会在此显示。批量保存只对当前分页有效，请勿跨分页操作</span>
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <draggableList :draggable="draggable" @isErrShow="onSetFieldDone" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight"
                class="commodity_stock_principal"
                @header-dragend="changeColWidth"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <el-table-column label="库存数量" width="180" class-name="edit_cell">
                    <template slot-scope="scope" style="height: 100%">
                        <el-input-number
                            v-model="formData[scope.row['rid']].quantity_balance"
                            clearable
                            @input="onExchange(scope.$index)"
                            placeholder=""
                            controls-position="right"
                        />
                    </template>
                </el-table-column>

                <el-table-column label="在途数量" width="180" class-name="edit_cell">
                    <template slot-scope="scope" style="height: 100%">
                        <el-input-number
                            clearable
                            v-model="formData[scope.row['rid']].in_transit_quantity"
                            @input="onExchange(scope.$index)"
                            placeholder=""
                            controls-position="right"
                        />
                    </template>
                </el-table-column>

                <el-table-column label="合作状态" width="180" class-name="edit_cell">
                    <template slot-scope="scope" style="height: 100%">
                        <vDropdown
                            style="width: 100%"
                            :is_clearable="false"
                            :initFromLocalData="partnerStatusDropData"
                            :model_key="scope.row['rid']"
                            model_name="请选择合作状态"
                            @onDropChange="onDropChange1"
                            :model_value_default="scope.row['partner_status'] || ''"
                        ></vDropdown>
                    </template>
                </el-table-column>

                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <div v-if="in_array(item.prop, ['xxx'])">
                                <el-link type="primary" @click="toDetail(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>

                <!-- <el-table-column label="操作" width="80">
                    <template slot-scope="scope" style="height: 100%">
                        <el-tooltip class="item" effect="dark" content="保存" placement="top-start">
                            <i class="el-icon-s-claim" @click="save(scope.row)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column> -->
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page="queryParams.page"
                    :page-size="queryParams.row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize, onSearch, in_array } from '../../../../../js/common';
import draggableList from '../../../../common/Drawer.vue';
import vSearchSelect from '@/components/common/dropdown/search.vue';

export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        vSearchSelect
    },
    name: 'repertoryPrincipalListComponent',
    data() {
        return {
            draggable: {
                data_name: 'commodity_stock_principal'
            },
            save_loading: false,
            loading: true,
            tableData: [],
            colData: [],
            total: 0,
            // sort: '', //排序参数
            // data_name: '', //排序参数
            queryParams: {},
            partnerStatusDropData: [],
            testdata: {},
            formData: {}
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        this.recoveryQueryParams('page');
        this.initPartnerStatusDropData();
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            this.recoveryQueryParams();
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.queryParams.row = 10;
                // 填入相应的参数，调用getList(0);
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        in_array,
        initPartnerStatusDropData() {
            this.$api['dropdownPartnerStatus']({ is_all: true })
                .then((res) => {
                    this.partnerStatusDropData = [];
                    res.data.forEach((item) => {
                        this.partnerStatusDropData.push({
                            value: item['value'],
                            label: item['name']
                        });
                    });
                })
                .catch((error) => {});
        },
        //跳转详情
        toDetail(row, prop) {},
        initQueryParams() {
            this.queryParams = {
                page: 1,
                row: 25,
                is_export: 0
            };
            this.saveQueryParams();
        },
        onDropChange(key, value) {
            this.queryParams[key] = value;
        },
        onDropChange1(key, value) {
            if (this.formData[key]) {
                this.formData[key]['partner_status'] = value;
            } else {
                this.formData[key] = {
                    partner_status: value
                };
            }
        },
        saveQueryParams() {
            if (!this.postList.params) {
                localStorage.setItem('commodity_stock_principal_params', JSON.stringify(this.queryParams));
            }
        },
        // 分页参数需要在beforeMount初始化，先兼容下
        recoveryQueryParams(type = 'common') {
            //详情内调用不用本地存储的params
            if (!this.postList.params) {
                //列表页面调用 优先取本地存储
                const queryParams = JSON.parse(localStorage.getItem('commodity_stock_principal_params'));
                if (queryParams) {
                    if (type == 'common') {
                        this.queryParams = queryParams;
                    } else {
                        this.queryParams.page = queryParams.page || 1;
                        this.queryParams.row = queryParams.row || 25;
                    }
                } else {
                    this.initQueryParams();
                }
            }
        },
        //子组件更新完毕
        onSetFieldDone(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('commodity_stock_principal', this, 3);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).commodity_stock_principal;
        },
        // 获取列表 0-非搜索 1-搜索 2-下载
        getList(search_type = 0) {
            onSearch(search_type, this, 'stockSourcePrincipalLists');
        },
        // onSearch后续处理逻辑，在这里写
        afterSearch() {
            this.formData = {};
            for (let x of this.tableData) {
                this.formData[x['rid']] = {
                    partner_status: x['partner_status'],
                    quantity_balance: x['quantity_balance'],
                    in_transit_quantity: x['in_transit_quantity']
                };
            }
        },
        currentChange(page) {
            this.queryParams.page = page;
            this.saveQueryParams();
            this.getList(0);
        },
        sizeChange(row) {
            this.queryParams.row = row;
            this.saveQueryParams();
            this.getList(0);
        },
        // 保存
        save(row) {
            if (this.formData[row.rid]) {
            } else {
            }
        },
        onExchange(index) {
            // 以下2行用于界面上的input有变化效果（否则跟readonly一样），但是不会变更tableData
            // 数据变更在v-model上的formData上
            let moment = this.tableData[index];
            this.$set(this.tableData, index, moment);
        },
        // 批量保存
        batchSave() {
            this.save_loading = true;
            var saveData = {
                data: []
            };

            this.tableData.forEach((item) => {
                if (
                    this.formData[item.rid] &&
                    (this.formData[item.rid]['partner_status'] != item.partner_status ||
                        this.formData[item.rid]['quantity_balance'] != item.quantity_balance ||
                        this.formData[item.rid]['in_transit_quantity'] != item.in_transit_quantity)
                ) {
                    saveData['data'].push({
                        rid: item.rid,
                        partner_status: this.formData[item.rid]['partner_status'],
                        quantity_balance: this.formData[item.rid]['quantity_balance'],
                        in_transit_quantity: this.formData[item.rid]['in_transit_quantity']
                    });
                }
            });

            if (saveData['data'].length == 0) {
                this.save_loading = false;
                this.$message.error('没有需要更新的数据');
                return false;
            }

            this.$api['stockSourcePrincipalUpdate'](saveData)
                .then((res) => {
                    this.save_loading = false;
                    this.$message.success('更新成功');
                    this.reload();
                })
                .catch((error) => {
                    this.save_loading = false;
                });
        },
        reset() {
            this.initQueryParams();
            this.getList();
        }
    }
};
</script>
<style lang="scss" scoped>
// 库存数量/在途数量/合作状态 三列内是输入控件，
// 需覆盖全局 .cell{height:14px} 造成的压扁裁切，让控件正常显示
::v-deep .el-table__cell.edit_cell .cell {
    height: auto !important;
    line-height: normal !important;
    overflow: visible !important;
}
</style>